import React from 'react'
import { IThreeBarsBoxProps } from './three-bars-box-props.interface'
import './three-bars-box.scss'
import three_bars from 'theme/images/three-bars.svg'

const ThreeBarsBox: React.FC<IThreeBarsBoxProps> = ({ children, extraClassName = '', nodeRef }) => {
  return (
    <div className={'edisu-three-bars-box ' + extraClassName} ref={nodeRef}>
      <div className="bars">
        <img src={three_bars} alt="" className="top-bars" />
      </div>
      <div className="content-wrapper">{children}</div>

      <div className="bars ion-hide-sm-down">
        <img src={three_bars} alt="" className="bottom-bars" />
      </div>
    </div>
  )
}

export default ThreeBarsBox
